import { PageHeroProps } from './PageHero';
import { cfImage } from '../../../lib/stringUtils';
import theme from '../../../lib/theme';
const { mediaSizes, font, colors, scale, media, } = theme;

export default ({
	background,
}: PageHeroProps) => ({
	container: {
		paddingTop: '0!important',
		backgroundImage: background && background.type === 'image'
			? `url(${cfImage(background.url, { format: 'webp', fit: 'cover' })})`
			: 'none',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		margin: `0 0 ${scale.m} 0!important`,
		padding: `${scale.m} ${scale.xs}!important`,
		minHeight: '250px',
		
		[media.s.up]: {
			minHeight: '350px!important',
			padding: `${scale.m} 0!important`,
		},
	},

	pageHeroWrapper: {
		maxWidth: '600px',
		width: mediaSizes.xxl ?? '1200px',
		margin: '0 auto',
		zIndex: 1,
	},

	heading1: {
		fontSize: font.xxxl,
		color: `${background && background.text_colour ? background.text_colour : colors.white}!important`,
		textAlign: 'right',
		fontWeight: `${font.bold}!important`,
		marginBottom: scale.xs,
		
		[media.s.down]: {
			fontSize: font.xxl,
		},
	},

	description: {
		fontSize: font.l,
		color: `${background && background.text_colour ? background.text_colour : colors.white}!important`,
		textAlign: 'right',
		fontWeight: `${font.normal}!important`,

		'a': {
			display: 'inline-block',
			alignItems: 'center',
			justifyContent: 'center',
			backgroundColor: colors.sas.primary,
			color: `${background && background.text_colour ? background.text_colour : colors.white}!important`,
			padding: `${scale.xxs} ${scale.s}`,
			textDecoration: 'none',
			fontWeight: `${font.bold}!important`,
			fontSize: font.s,
			marginTop: scale.xs,
			transition: 'all 150ms linear',

			'&:after': {
				content: "' >'",
				marginLeft: scale.xxs,
				color: `${background && background.text_colour ? background.text_colour : colors.white}!important`,
				fontSize: font.m,
			},

			'&:hover': {
				backgroundColor: colors.sas.primary_dark,
			},
		},

		[media.s.down]: {
			fontSize: font.s,
		},

	}
});